import { render } from "./RiskListPopup.vue?vue&type=template&id=dcdc6c04"
import script from "./RiskListPopup.js?vue&type=script&lang=js"
export * from "./RiskListPopup.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__